module.exports = __webpack_public_path__ + "media/images/sp/banner/hokepon_reserve_brand-954902e6e3d41922722b2d3ccf44ecf0.png";